export default __webpack_public_path__ + "static/media/(Fast)Mennekes (Type 2).ffd96078.svg";